module.exports = __webpack_public_path__ + "static/media/1569521678011811899332.da1dcc16.jpg";